import * as Sentry from '@sentry/react';
import { useEffect } from 'react';
import { useRouteError } from 'react-router-dom';
import Error from '../../pages/Error/Error';

const RouteErrorBoundary = () => {
  const error = useRouteError();

  useEffect(() => {
    Sentry.captureException(error);
  }, [error]);

  return <Error />;
};

export default RouteErrorBoundary;
